import _ from 'lodash';
import axios from 'axios';
import csrfToken from '../../../shared/meta';

const base = '/api/v1/lwadmin/categories';

export function getAll() {
  return axios.get(base, { cache: { ignoreCache: true } });
}

export function getById(id) {
  return axios.get(`${base}/${id}`, { cache: { ignoreCache: true } });
}

export function createOrUpdate(category) {
  const url = category.id ? `${base}/${category.id}` : base;
  return axios.post(
    url,
    _.pick(category, ['id', 'name', 'description']),
    { headers: { 'X-CSRF-TOKEN': csrfToken() } },
  );
}

export function regenSlug(id) {
  return axios.post(
    `${base}/${id || ''}/regenerate_slug`,
    null,
    { headers: { 'X-CSRF-TOKEN': csrfToken() } },
  );
}
